export const compareStringsAccentInsensitive = (a: string = '', b: string = ''): number => {
    const collator = new Intl.Collator('pt-BR', {
        sensitivity: 'base', // ignore accents and case
        ignorePunctuation: true,
    });
    return collator.compare(a, b);
};

// Remove acentos, converte para lower-case e trim – útil para buscas e comparações
export const normalizeString = (value: string | undefined | null): string => {
    if (!value) return '';
    return value
        .normalize('NFD') // separa diacríticos
        .replace(/[\u0300-\u036f]/g, '') // remove marcas
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}; 